import React from 'react';
import PropTypes from 'prop-types';
import { IMask, IMaskInput } from 'react-imask';

// Custom mask input component for date range
const InputMaskCustom = React.forwardRef(function DateMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
        <IMaskInput
            {...other}
            name={props.name}
            mask={[
                {
                    mask: 'dd/mm/yyyy-dd/mm/yyyy',
                    blocks: {
                        dd: { mask: IMask.MaskedRange, from: 0, to: 31 },
                        mm: { mask: IMask.MaskedRange, from: 0, to: 12 },
                        yyyy: { mask: IMask.MaskedRange, from: 1900, to: 2199 }
                    }
                }
            ]}
            inputRef={ref}
            onAccept={(value) => onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});

InputMaskCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};

export default InputMaskCustom;
